/* eslint-disable no-param-reassign */
import type { Data } from '../../specProcessor';
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as SummaryTextLayerSpec } from '../../../../layer/preset/text/summaryText';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

type SummaryTextLayerType = StandardChartLayerSpec & SummaryTextLayerSpec & ILayerTypeSpec;

// 创建概要文本数据类型验证器
const validateSummaryTextDataTypes = createDataTypeValidator('summaryText', [
  { field: 'x', type: ['string', 'date'] }
]);

// 创建概要文本编码验证器
const validateSummaryTextEncoding = createEncodingValidator([{ field: 'x' }]);

// 额外的检查函数 - 验证数据行数
const additionalSummaryTextChecks = (layer: SummaryTextLayerType, data: Data) => {
  const { dataIndex = 0 } = layer;

  if (!data[dataIndex] || !data[dataIndex].values || !data[dataIndex].values.length) {
    utils.logger.warn(
      'warning',
      `No data available for "${layer.type}" layer at dataIndex: ${dataIndex}`
    );
    return;
  }

  // 检查数据量是否符合要求（必须为1）
  if (data[dataIndex].values.length !== 1) {
    utils.logger.warn(
      'warning',
      `Data length must be 1 for "${layer.type}" layer, but got ${data[dataIndex].values.length}`
    );
    layer.__isEncodingValid = false;
  }
};

// 创建并导出概要文本处理器
export const summaryText = createLayerProcessor<SummaryTextLayerType>(
  'summaryText',
  validateSummaryTextEncoding,
  validateSummaryTextDataTypes,
  additionalSummaryTextChecks
);
